import { RouterLink } from '@redux-first-router-link';
import { Text } from '@simplywallst/ui-core';
import { usePredefinedScreeners } from '../hooks/usePredefinedScreeners';
import { Link, SmallBadge } from '../styled';
import { useTracking } from 'react-tracking';

type TableRowType = ReturnType<
  typeof usePredefinedScreeners
>['data']['companyPredefinedScreeners'][number];

export const TableRowScreenerPredefined = ({
  name,
  id,
  slug,
  resultPreview,
}: TableRowType) => {
  const { trackEvent } = useTracking();
  if (slug === null) return;
  const url = `/discover/investing-ideas/${id}/${slug}`;

  const handleTracking = () => {
    trackEvent({
      action: 'click',
      modifier: 'list_item',
      screenerId: id,
      screenerName: name,
    });
  };

  return (
    <tr data-cy-id="my-screeners-item-predefined">
      <td>
        <RouterLink to={url} onClick={handleTracking}>
          <Text
            typography="tiny"
            as="span"
            style={{ display: 'block' }}
            isTruncated
          >
            {name}
          </Text>
        </RouterLink>
      </td>
      <td>
        <Link to={url} onClick={handleTracking}>
          <SmallBadge
            tone={
              (resultPreview.newCompaniesTotalHits ?? 0) > 0
                ? 'attention'
                : undefined
            }
          >
            {resultPreview.newCompaniesTotalHits ?? '0'} New
          </SmallBadge>
        </Link>
      </td>
    </tr>
  );
};
